import React   from "react";

import { Link } from 'react-router-dom';

import { Card, CardBody, CardTitle, CardFooter, Row, Col
  } from "reactstrap";


export const  Kpis = ( { values } ) => { 
     return (
       <>

      <Row>
      {values.tags && values.tags.map( ( kpi ) => {
        return (
          <>
              { kpiCard( kpi ) }
          </>
          )
        } )
      }
      </Row>
      </>
    );
  }

const kpiCard = ( kpi ) => {
  return (
    <Col md="4">
  <Card className="card-stats">
    <CardBody>
      <Row>
        <Col md="3" xs="4">
          <div className="icon-big text-center" style={{ color: kpi.tag_color}} >
            <i className={kpi.tag_icon?kpi.tag_icon:"fa fa-info-circle"} />
          </div>
        </Col>
        <Col md="9" xs="8">
          <div className="numbers">
            <p className="card-category">{kpi.tag_label}</p>
            <CardTitle tag="p">{kpi.total}</CardTitle>
            <p />
          </div>
        </Col>
      </Row>
    </CardBody>
    <CardFooter>
      <hr />
      <div className="stats">
        {kpi.tag_description}
        {kpi.tag_url &&
          <div className="ml-auto text-right">
              <Link
                to={kpi.tag_url}
              >Ver más </Link>
          </div>
        }
      

        
      </div>
    </CardFooter>
  </Card>
  </Col>
  )
}
